import React from "react";
import { View } from "react-native";
import { IconSize, useIconSize, useTheme, AHIcon } from "arkh";

export const EmptyResult = ({
  size,
  absoluteSize,
}: {
  size?: IconSize;
  absoluteSize?: number;
}) => {
  const theme = useTheme();
  const iconSize = useIconSize("medium");
  const resolvedSize = absoluteSize ?? iconSize;
  return (
    <View style={{ width: resolvedSize }}>
      <AHIcon
        type="minus"
        forceSize={resolvedSize}
        customColor={theme.negative}
      />
    </View>
  );
};
